import { render, staticRenderFns } from "./EmailPlaceholders.vue?vue&type=template&id=1c6b4937"
import script from "./EmailPlaceholders.vue?vue&type=script&lang=ts"
export * from "./EmailPlaceholders.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports